<template>
  <div>
    <CRow>
      <CCol md="12">
        <CCard>
          <CCardHeader class="p-1">
            <CRow>
              <CCol col="8" style="text-align: start ;padding:10px 20px 0 20px ">

                <strong v-if="status_form==0">{{ $t('sidebars.inventoryTransfer') }}</strong>

              </CCol>
              <CCol col="4" style="text-align: end">


<!--                <CButton v-if="status_form==0"  class="mr-1 ml-1" @click="insert_data()" type="submit" size="sm" color="secondary">-->
<!--                  {{ $t('buttons.submit') }}-->
<!--                </CButton>-->

<!--                <CButton-->
<!--                    class="mr-1"-->
<!--                    size="sm"-->
<!--                    color="secondary"-->
<!--                >{{ $t("buttons.cancel") }}-->
<!--                </CButton>-->

              </CCol>
            </CRow>
          </CCardHeader>
          <CCardBody>
            <BTabs >
              <BTab :title="$t('exitInventoryProducts')" v-if="get_access('warehouse_output')">
                <WarehouseOutput/>
              </BTab>
              <BTab :title="$t('InventoryBill')">
                <InWayInvetoryOrders/>
              </BTab>
              <BTab :title="$t('ProductOrderList')">
                <InventoryAllOrderList/>

              </BTab>

              <BTab :title="$t('inventoryNeed')" v-if="get_access('inventory_replenishment')">
                <InventoryReplenishment/>
              </BTab>


              <BTab v-if="false" :title="$t('intoInventory')">
                <CRow>
                  <CCol col="2">
                    <CInput
                        :placeholder="$t('tables.factorId')"
                    />
                  </CCol>
                  <CCol col="2">
                    <CButton size="sm" color="secondary">
                      {{$t('search')}}
                    </CButton>
                  </CCol>
                </CRow>

                <CDataTable
                    :items="request_product_to_inventory_items"
                    :fields="request_product_to_inventory_fields"
                    striped
                    border
                    :items-per-page="200"
                    hover
                    pagination
                >


                  <template #summary="{item}">

                    <td>
                      <strong >{{ item.docDesc }}</strong>

                    </td>

                  </template>


                </CDataTable>
                <CButton @click="insert_data()" type="submit" size="sm" color="secondary">
                  {{$t('acceptProducts')}}
                </CButton>
              </BTab>


              <BTab :title="$t('betweenInventory')">
             <BeetweenInventory/>
              </BTab>
<!--              <CTab :title="$t('returnProducts')">-->
<!--              <ProductReturnInventory/>-->
<!--              </CTab>-->
<!--              <CTab :title="$t('damageProducts')">-->
<!--              <DamageProducts/>-->
<!--              </CTab>-->
<!--              <CTab :title="$t('returnProductsList')">-->
<!--              <ReturnDocList/>-->
<!--              </CTab>-->


            </BTabs>


          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
    <CModal
        :show.sync="change_status_modal"
        :no-close-on-backdrop="true"
        color="transparent"
        border-color="primary"
        size="sm"
        :title="$t('components.changeStatus')"
    >

      <CRow>
        <CCol col="12">
          <CSelect
              :label="$t('components.status')"
              horizontal
              :value.sync="selected_status"
              :options="status_list"
          />
          <CInput
              :label="$t('components.summary')"
              horizontal
              v-model="change_status_summary"
          />


        </CCol>
      </CRow>
      <template #footer>
        <CButton @click="change_status_data(0)"
                 color="success"
        >{{ $t("buttons.ok") }}
        </CButton>
        <CButton
            @click="change_status_modal = false"
            color="danger"
        >{{ $t("buttons.cancel") }}
        </CButton>
      </template>
    </CModal>
  </div>
</template>

<script>
import axios from "axios";
import {bus} from '../../../main';
import moment from 'moment-jalaali'
import BTabs from "../../tabs/BTabs";
import InWayInvetoryOrders from './InWayInvetoryOrders'
import InventoryAllOrderList from "./InventoryAllOrderList";
import ExitInsiteOrders from "@/views/panel/inventory/ExitInsiteOrders";
import DamageProducts from "./DamageProducts";
import InventoryReplenishment from "./InventoryReplenishment";
// import ReturnDocList from "./ReturnDocList";
var items = [];
import ProductReturnInventory from "./ProductReturnInventory";
import BeetweenInventory from "./BeetweenInventory";
import WarehouseOutput from "./WarehouseOutput";
import BTab from "../../tabs/BTab";
export default {
  name: 'Login',
  components: {
      BTab,
    BeetweenInventory,
    WarehouseOutput,
    // ReturnDocList,
    InventoryReplenishment,
    DamageProducts,
    ExitInsiteOrders,
    BTabs,
    InWayInvetoryOrders,
    InventoryAllOrderList,
    ProductReturnInventory
  },
  data() {
    return {
      confirm_delete_name:"confirm"+new Date().getTime()+"_"+this.$vnode.tag,
      start_date: '',
      end_date: '',
      change_status_modal: false,
      selected_factors_for_status: [],
      selected_status: 0,
      status_list: [{label: this.$t('select'), value: 0}, {label: this.$t('inDriver'), value: 25}],
      // 23	ارجاع	10
      // 24	کالاها آماده ارسال	10
      // 25	تحویل سفیر	10
      // 26	در دست سفیر	10
      // 27	در مسیر تحویل	10
      // 28	تحویل شد	10
      change_status_summary: '',
      id_checkbox_items: [],
      id_checkbox_items_delivery: [],
      id_checkbox_items_insite: [],


      request_product_to_inventory_items: items.map((item, row_id) => {
        return {...item, row_id}
      }),
      request_product_to_inventory_fields: [
        {key: 'row', label: this.$t('tables.row'), _style: 'width:10%'},
        {key: 'code', label: this.$t('tables.code'), _style: 'width:10%'},

        {key: 'name', label: this.$t('tables.name'), _style: 'width:10%'},
        {key: 'j', label: this.$t('submitQty'), _style: 'width:20%'},
        {key: 'color', label: this.$t('receivedQty'), _style: 'width:10%;'},
        {key: 'image', label: '▢', _style: 'width:20%;'},
        // {key: 'operation', label: this.$t('tables.operation'), _style: 'width:20%;'},
      ],


      exit_product_inventory_items: [],
      exit_delivery_product_inventory_items: [],
      exit_product_inventory_fields: [

        {key: 'masterId', label: this.$t('tables.number'), _style: 'width:2%'},
        // {key: 'انبار', _style: 'width:10%'},
        {key: 'productName', label: this.$t('components.productName'), _style: 'width:10%'},
        {key: 'qty', label: this.$t('requestQty'), _style: 'width:20%'},
        {key: 'existance', label: this.$t('balanceQty'), _style: 'width:15%'},
        // {key: 'toziKonande', label: this.$t('tables.driver'), _style: 'width:15%'},

        {key: 'select', label: this.$t('tables.select'), _style: 'width:2%'},

        // {key: 'operation', label: this.$t('tables.operation'), _style: 'width:20%;'},
      ],
      exit_factors_inventory_fields: [

        {key: 'recId', label: this.$t('tables.number'), _style: 'width:2%'},
        // {key: 'price', label: this.$t('tables.price'), _style: 'width:10%'},
        {key: 'customer', label: this.$t('tables.customer'), _style: 'width:20%'},
        {key: 'placeName',label: this.$t('inventory'), _style: 'width:10%'},
        {key: 'toziKonande',label: this.$t('driver'), _style: 'width:10%'},
        {key: 'routeName',label: this.$t('route'), _style: 'width:10%'},

        // {key: 'user', label: this.$t('tables.user'), _style: 'width:15%'},
        {key: 'status', label: this.$t('DisabilityStatus'), _style: 'width:15%'},

        // {key: 'operation', label: this.$t('tables.operation'), _style: 'width:20%;'},
        {key: 'select', label: this.$t('tables.select'), _style: 'width:2%'},

        // {key: 'operation', label: this.$t('tables.operation'), _style: 'width:20%;'},
      ],


      return_product_inventory_fields: [
        {key: 'row', label: this.$t('tables.row'), _style: 'width:10%'},
        {key: 'code', label: this.$t('tables.code'), _style: 'width:10%'},

        {key: 'name', label: this.$t('beforeQty'), _style: 'width:10%'},
        {key: 'j', label: this.$t('retQty'), _style: 'width:20%'},
        // {key: 'operation', label: this.$t('tables.operation'), _style: 'width:20%;'},
      ],
      status_form: 0,
      check_all_exit: false,
      check_all_exit_delivery: false,
    }
  },
  mounted() {

      this.start_date = this.get_day_before_today(1);
    this.end_date = this.get_today();

    this.$root.root_validate_errors = [];

    this.get_all_data();
    bus.$on(this.confirm_delete_name, (data) => {
      // alert(data);
      if (data == "true") {
        this.delete_item();

      } else {
        this.status_form = 0;
      }
    });
  }, watch: {
    '$route.params.cat_id': function () {
      this.get_all_data();
    },

    'start_date': function () {
      this.get_all_data();
    },
    'end_date': function () {
      this.get_all_data();
    },
    'check_all_exit': function () {
      if (this.check_all_exit) {
        this.id_checkbox_items = [];

        this.exit_product_inventory_items.forEach((val) => {
          this.id_checkbox_items.push(val.recId);
        });
      } else {
        this.id_checkbox_items = [];
      }
    },

    'check_all_exit_delivery': function () {
      if (this.check_all_exit_delivery) {
        this.id_checkbox_items_delivery = [];

        this.exit_delivery_product_inventory_items.forEach((val) => {
          this.id_checkbox_items_delivery.push(val.recId);
        });
      } else {
        this.id_checkbox_items_delivery = [];
      }
    }
  },
  methods: {
    check_all() {
      console.log('check all clicked');
    },
    goShowDocument(item) {

      this.$router.push({path: '/dashboard/documents/show/' + item.recId});
    },
    change_status_data(index) {
      if (this.selected_status == 0) {
        return false;
      }
      if(this.selected_factors_for_status.length==0){
        return false;

      }
      this.change_status_modal = false;
      var self = this;

      const formData = new FormData();

      formData.append('FactorId', this.selected_factors_for_status[index]);
      formData.append('StatusId', this.selected_status);


      axios.post('AddFactorStatus', formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {
if(self.selected_factors_for_status.length - 1< index){
  self.change_status_data(index+1);
}else{
  self.get_all_data();
}


        } else {
          self.$root.modal_component.show_danger_modal(self.$t("dialogs.error"), content_data.message);

        }


      })
          .catch(function (error) {
            console.log(error);
          });
    },
    open_file_selector() {
      this.$refs.file_selector.$el.getElementsByTagName('input')[0].click()
    },
    validateForm: function () {
      this.$root.root_validate_errors = [];

      if (this.name != '' && this.color != '') {
        return true;
      }


      if (this.name == '') {
        this.$root.root_validate_errors.push(this.$t('dialogs.insertName'));
      }

      if (this.color == '') {
        this.$root.root_validate_errors.push(this.$t('dialogs.insertColor'));
      }
      // if (this.description == '') {
      //   this.$root.root_validate_errors.push(this.$t('dialogs.insertSummary'));
      // }
      return false;
      // e.preventDefault();
    },
    get_style(color) {
      return {

        backgroundColor: color

      }
    },
    get_all_data(){
      this.get_exit_products();
      this.get_delivery_lists()
    },
    get_image_file(item) {
      // console.log("image url is " + item.imageName);
      return this.$root.base_url + item.imageName;
    },
    edit_item(item) {
      // this.$set(this.items[item.row_id], '_toggled', !item._toggled)
      this.name = this.items[item.row_id].catTitle;
      this.color = this.items[item.row_id].color;
      this.code = item.code;
      this.description = this.items[item.row_id].summary;
      this.previewImage = this.items[item.row_id].image;
      this.status_form = this.items[item.row_id].recId;
      setTimeout(() =>
              this.$refs.add_container.scrollIntoView()
          , 500);
      // this.$nextTick(() => {
      //     this.collapseDuration = 0
      // })
    }, emptyList() {
      // this.$set(this.items[item.row_id], '_toggled', !item._toggled)
      this.name = '';
      this.color = '';
      this.description = '';
      this.previewImage = '/img/placeholder.png';
      // this.$nextTick(() => {
      //     this.collapseDuration = 0
      // })
    },
    get_exit_products() {
      var self = this;

      const formData = new FormData();

      formData.append('FirstDate', this.start_date);
      formData.append('SecondDate', this.end_date);
      formData.append('DocType', 3);
      formData.append('StatusList[]', 24);


      axios.post('GetDocsByForOutputEntry', formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {
          self.exit_product_inventory_items = content_data.data.map((item, row_id) => {
            return {...item, row_id}
          });
        } else {
          self.$root.modal_component.show_danger_modal(self.$t("dialogs.error"), content_data.message);

        }


      })
          .catch(function (error) {
            console.log(error);
          });

    },
    get_delivery_lists() {
      var self = this;

      const formData = new FormData();

      formData.append('FirstDate', this.start_date);
      formData.append('SecondDate', this.end_date);
      formData.append('DocType', 3);
      formData.append('DeliveryType', 21);


      axios.post('GetDocsByForDelivery', formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {
          self.exit_delivery_product_inventory_items = content_data.data.map((item, row_id) => {
            return {...item, row_id}
          });
        } else {
          self.$root.modal_component.show_danger_modal(self.$t("dialogs.error"), content_data.message);

        }


      })
          .catch(function (error) {
            console.log(error);
          });

    },
    goSubCategories(item, index) {

      this.$router.push({path: '/dashboard/base/categories/' + this.items[index].recId});
// this.get_categories();
      // this.$router.push({ path: '/posts/'});
    },
    goToProductList(item) {
      this.$router.push({path: "/dashboard/products/list-cat/" + item.recId})
      // this.$router.push({ path: '/dashboard/base/categories/'+this.items[index].recId});
// this.get_categories();
      // this.$router.push({ path: '/posts/'});
    },
    handleFileUpload(files, e) {
      this.file = e.target.files[0];
      this.previewImage = URL.createObjectURL(this.file);
    },
    insert_data() {


      if (!this.validateForm()) {
        // console.log("validate form is false"+this.validate_errors);
        return true;
      }

      let self = this;
      const formData = new FormData();
      let url;
      if (this.status_form == 0) {
        url = "AddMainCat";
      } else {
        url = "EditMainCat";
        formData.append('id', this.status_form)

      }

      formData.append('file', this.file);
      formData.append('MainCatTitle', this.name);
      formData.append('Color', this.color);
      formData.append('Code', this.code);
      if (this.$route.params.cat_id != null) {
        formData.append('IsParent', this.$route.params.cat_id);

      } else {
        formData.append('IsParent', 0);

      }
      formData.append('summary', this.description);
      axios.post(url, formData, {}).then((res) => {



        self.$root.modal_component.show_api_response_modals(res);

        self.status_form = 0;
        self.name = '';
        self.color = '#ffffff';
        self.code = '';
        self.description = '';
        self.previewImage = '/img/placeholder.png';
        self.get_all_data();


      })

          // axios.post(  '/admin/category', {
          //     name: self.name,
          //     description: self.description,
          //     image: self.image,
          //     cat: 0,
          // }).then(function (response) {
          //     self.name = '';
          //     self.description = '';
          //     // localStorage.setItem("api_token", response.data.access_token);
          //     // self.$router.push({ path: 'notes' });
          // })
          .catch(function (error) {
            console.log(error);
          });

    },
    delete_item_dialog(item) {
      this.$root.modal_component.show_confirm_modal(this.$t("dialogs.warning"), this.$t("dialogs.deleteMessage"), [this.$t("dialogs.ok")], this.confirm_delete_name);

      this.status_form = this.items[item.row_id].recId;

    }, delete_item() {


      let self = this;
      const formData = new FormData()
      let url;
      url = "DeleteCat";


      formData.append('id', this.status_form);

      axios.post(url, formData, {}).then((res) => {

        self.$root.modal_component.show_api_response_modals(res);
        self.status_form = 0;

        self.get_all_data();


      })
          .catch(function (error) {
            console.log(error);
          });
// this.get_categories();
      // this.$router.push({ path: '/posts/'});
    },
  }
}

</script>
